import useMyProductFormContext from '@src/hooks/product/form/useProductFormContext'
import FileSelector from '@src/components/inputs/FileSelector'
import DescriptionFormItem from '@src/components/product/form/ProductForm/DescriptionFormItem'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import LoadingIcon from '@src/components/icon/LoadingIcon'

const DescriptionForm = () => {
	const { getDescriptionFormProps } = useMyProductFormContext()
	const {
		selectDescriptionFile,
		descriptionFields,
		loadingDescFile,
		descFileTag,
		removeDescription,
		errorMsg,
		isError,
	} = getDescriptionFormProps()
	// uploadBtnStyle
	return (
		<div>
			<SelectorWrapper>
				<FileSelector
					ref={descFileTag}
					label="상품 상세 이미지"
					buttonTxt="이미지 추가"
					accept="image/jpeg, image/png"
					onChange={selectDescriptionFile}
					wrapperStyle={css`
						padding: 0;
						flex-direction: column;
					`}
					uploadBtnStyle={css`
						background: #ffcf19;
						border-radius: 4px;
						font-weight: 600;
						font-size: 1.4rem;
						line-height: 1.7rem;
						letter-spacing: 0.2px;
						color: #000000;
						width: auto;
						height: auto;
						padding: 1rem;
					`}
					errorMsg={errorMsg}
					isError={isError}
				/>
				{loadingDescFile && (
					<LoadingIconWrapper>
						<LoadingIcon width={20} height={20} />
					</LoadingIconWrapper>
				)}
			</SelectorWrapper>

			{descriptionFields.map((description, index) => {
				return (
					<div key={`description-list-id-${description.id}`}>
						<DescriptionFormItem
							description={description}
							onCancelImg={() => {
								removeDescription(index)
							}}
						/>
					</div>
				)
			})}
		</div>
	)
}
const SelectorWrapper = styled.div`
	display: inline-block;
	position: relative;
`
const LoadingIconWrapper = styled.div`
	position: absolute;
	top: 34px;
	left: 0;
	right: 0;
	bottom: 0;
	margin: auto;
	background: #00000066;

	display: flex;
	align-items: center;
	justify-content: center;
`

export default DescriptionForm
